import { render } from "./order-list.vue?vue&type=template&id=697d4526&scoped=true&ts=true"
import script from "./order-list.vue?vue&type=script&lang=ts"
export * from "./order-list.vue?vue&type=script&lang=ts"

import "./order-list.vue?vue&type=style&index=0&id=697d4526&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697d4526"]])

export default __exports__